// extracted by mini-css-extract-plugin
module.exports = {"total":"TotalPrice_total__m46_T"};